var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"back-button",on:{"click":function($event){return _vm.changeMenuVisibility(true)}}},[_vm._v(" Voltar ")]),(
      _vm.slug)?_c('post'):_c('blog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }